export default __webpack_public_path__ + "static/media/035-taco.5c6d1d93.svg";